import { cn } from "@/lib/cn";
import type { AccountHealth } from "@/api/accounts";

const LABELS: Record<AccountHealth, string> = {
  online: "В сети",
  limited: "Лимит",
  paused: "Пауза",
  banned: "Бан",
  idle: "Простой",
};

const STYLES: Record<AccountHealth, string> = {
  online: "bg-success/15 text-success",
  limited: "bg-warning/15 text-warning",
  paused: "bg-white/[0.06] text-text-muted",
  banned: "bg-danger/15 text-danger",
  idle: "bg-white/[0.04] text-text-dim",
};

const DOT_STYLES: Record<AccountHealth, string> = {
  online: "bg-success shadow-[0_0_8px_rgba(74,222,128,0.6)]",
  limited: "bg-warning shadow-[0_0_8px_rgba(251,191,36,0.6)]",
  paused: "bg-text-muted",
  banned: "bg-danger",
  idle: "bg-text-dim",
};

interface HealthPillProps {
  health: AccountHealth;
  detail?: string | null;
  className?: string;
}

export function HealthPill({ health, detail, className }: HealthPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 text-[11px] font-medium",
        "px-2 py-1 rounded-md whitespace-nowrap",
        STYLES[health],
        className,
      )}
    >
      <span className={cn("size-1.5 rounded-full", DOT_STYLES[health])} />
      {LABELS[health]}
      {detail && <span className="opacity-70 ml-0.5">· {detail}</span>}
    </span>
  );
}
